function is(x, y) {
  if (x === y)
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  return x !== x && y !== y;
}
export {
  is
};
//# sourceMappingURL=is.js.map